import React, { forwardRef, SyntheticEvent } from 'react';
import { useRouter } from 'next/router';
import { Link as NextLink } from '@framework/router/Next/Link';
import { closePanelOnNavigate } from './panelManager';

export interface IUrlObject {
  pathname?: string,
  query?: Record<string, string | string[]>,
  hash?: string,
}

interface IPanelLinkProps {
  title?: string,
  dataTest?: string,
  className?: string,
  isActive?: boolean,
  isExactActive?: boolean,
  activeClassName?: string,
  to: string | IUrlObject,
  target?: string,
  children?: React.ReactNode,
  onClick?: (e: SyntheticEvent) => void,
  onMouseEnter?: (e: any) => void,
  as?: string,
  ariaCurrent?: 'page',
  disabled?: boolean,
  passHref?: boolean,
  shallow?: boolean,
  id?: string,
  locale?: string,
}

const PanelLink = forwardRef<HTMLAnchorElement, IPanelLinkProps>(({
  onClick,
  to,
  isActive,
  ...props
}, ref) => {
  const router = useRouter();

  const handleClick = (e: SyntheticEvent) => {
    const currentPath = router.asPath;
    let targetPath: string;

    if (typeof to === 'string') {
      targetPath = to;
    } else {
      const pathname = to.pathname || '';
      const queryString = to.query
        ? `?${ Object.entries(to.query)
          .map(([key, value]) => {
            const queryValue = Array.isArray(value) ? value[0] : value;
            return `${ key }=${ queryValue }`;
          })
          .join('&') }`
        : '';
      const hash = to.hash || '';
      targetPath = `${ pathname }${ queryString }${ hash }`;
    }

    if (currentPath !== targetPath) {
      closePanelOnNavigate();
    }

    onClick?.(e);
  };

  return (
    <NextLink
      { ...props }
      to={ to }
      onClick={ handleClick }
      ref={ ref }
      aria-current={ isActive ? 'page' : undefined }
    />
  );
});

export default PanelLink;
